import {Chart} from '../key-metrics.interfaces';

export class ChartUtils {

  public static getEmptyChart(): Chart {
    return {
      accus1: '',
      accus2: '',
      categorization: '',
      chartId: null,
      cliCoreId: null,
      data: [],
      displayOrder: null,
      family: '',
      id: null,
      isChart: null,
      time: null,
      title: '',
      type: '',
      chartConfig: null,
      table: null,
      entity: null,
      canvas: null,
      isLoading: null
    };
  }
}
